export const NOTIFICATION_MESSAGE = 'NOTIFICATION_MESSAGE';
